import React, { useState, useRef } from "react";
import { useGetEventManagerQuery } from "./EventManagerSlice";
import EventManagerExcerpt from "./EventManagerExcerpt";
import EditEventManager from "./EditEventManager";
import AddEventManager from "./AddEventManager";

const EventManager = () => {

    const refOpen = useRef(null)
    const [editEventManagers, setEditEventManagers] = useState({ name: "", number: "" });

    const {
        data: EventManager,
        isError
    } = useGetEventManagerQuery('getEventManager')

    const editEventManager = (EventManager) => {
        refOpen.current.click()
        setEditEventManagers({ name: EventManager.name, number: EventManager.number, id: EventManager.id });
    }

    return (
        <>
            {isError && <div>Something went wrong</div>}
            {EventManager &&
                <div className="container-fluid mt-5" >
                    <div className="d-flex justify-content-end">
                        <div className="text-right ">
                            <AddEventManager />
                        </div>
                    </div>

                    <div className="card card-dark mt-4" style={{ height: "50%" }}>
                        {
                            (
                                <div className="table-border-style">
                                    <div className="table-responsive sidebarhome ">
                                        <table className="table table-striped">
                                            <thead className="mobile-hidden">
                                                <tr className="text-center">
                                                    <th scope="col">Sr. No.</th>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">Number</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    EventManager?.ids?.map((id, index) => {
                                                        return (
                                                            <EventManagerExcerpt key={index} id={id} index={index} editEventManager={editEventManager} />
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            }

            <EditEventManager refOpen={refOpen} editEventManagers={editEventManagers} setEditEventManagers={setEditEventManagers} />

        </>
    )
}

export default EventManager;